import es from './translations/es';
import en from './translations/en';
import fr from './translations/fr';
import it from './translations/it';
import de from './translations/de';
import pt from './translations/pt';

export default {
    es,
    en,
    fr: { ...en, ...fr },
    it: { ...en, ...it },
    de: { ...en, ...de },
    pt: { ...en, ...pt }
};
